import React from 'react'
import headerStyles from '../styles/header.module.css'

const Line = () => (
  <div className={headerStyles.yellowLine}>
    <hr />
  </div>
)

export default Line
